import React, { useEffect, useState } from "react"
import { FastForward, Pause, Play, Rewind } from "react-feather"
import Colors from "../../helpers/Colors"
import "./styles.css"

export const ReadAloudMenu = () => {
  const [isPlaying, setIsPlaying] = useState(false)
  useEffect(() => {
    const PlayPauseBtn = document.querySelector("#play-pause-button")
    const callback = (e) => {
      setTimeout(() => {
        setIsPlaying(PlayPauseBtn.dataset.isplaying !== undefined)
      }, 100)
    }
    PlayPauseBtn.addEventListener("click", callback)
    return () => {
      PlayPauseBtn.removeEventListener("click", callback)
    }
  }, [])

  return (
    <div
      id="media-overlay-controls-container"
      className="d-flex flex-row align-items-center justify-content-center p-1"
      style={{ backgroundColor: Colors.GREEN, borderRadius: "0.6rem" }}
    >
      <button
        type="button"
        id="previous-segment-button"
        className="media-overlay-btn"
        disabled
      >
        <Rewind size={20} />
      </button>
      <button
        type="button"
        id="play-pause-button"
        className="media-overlay-btn"
        disabled
      >
        {isPlaying ? <Pause size={20} /> : <Play size={20} />}
      </button>
      <button
        type="button"
        id="next-segment-button"
        className="media-overlay-btn"
        disabled
      >
        <FastForward size={20} />
      </button>
      <div id="media-overlay-status" className="d-none"></div>
      <div id="media-overlay-playback-position" className="d-none"></div>
    </div>
  )
}
